module.exports = __webpack_public_path__ + "img/forgot.052db293.png";